import { NavLink } from "react-router-dom";
import { useLegacyMode } from "./LegacyModeContext";
import "./LegacyTopNav.css";

const legacyLinks = [
    { to: "/legacy/settings", label: "Settings" },
    { to: "/imports", label: "Bulk Import" },
    { to: "/legacy/vehicles", label: "Vehicles" },
    { to: "/legacy/mappings", label: "Product Fitments" },
    { to: "/legacy/export", label: "Data Export" },
    { to: "/legacy/universal", label: "Universal Mapping" },
    { to: "/legacy/documentation", label: "Documentation" },
    { to: "/legacy/account", label: "Account" },
];

const LegacyTopNav = () => {
    const { loading, isLegacy, status } = useLegacyMode();

    if (loading || !isLegacy) return null;

    const links = status?.hasTurn14Activity
        ? [...legacyLinks, { to: "/legacy/turn14", label: "Turn14 Integration" }]
        : legacyLinks;

    return (
        <nav className="LegacyTopNav" aria-label="Legacy PartFinder navigation">
            <ul className="LegacyTopNav__list">
                {links.map(link => (
                    <li key={link.to} className="LegacyTopNav__item">
                        <NavLink
                            to={link.to}
                            className={({ isActive }) =>
                                `LegacyTopNav__link${isActive ? " LegacyTopNav__link--active" : ""}`
                            }
                        >
                            {link.label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default LegacyTopNav;
